import { render, staticRenderFns } from "./EditarLista.vue?vue&type=template&id=1c81810b&scoped=true"
import script from "./EditarLista.vue?vue&type=script&lang=js"
export * from "./EditarLista.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c81810b",
  null
  
)

export default component.exports